module.exports = __webpack_public_path__ + "static/media/Type3Icon.4693c5a6.png";